import React from 'react';


interface Props {
  value: number;
  index: number;
}

const TabPanel: React.FC<Props> = ({ children, value, index }) => {
  return value === index ? <React.Fragment>{children}</React.Fragment> : null;
}

export default TabPanel;